export enum OfferView {
  LIST = 'list',
  CREATE = 'create',
  /** A draft – editable. */
  EDIT = 'edit',
  /** A sent, accepted or revoked offer – read only. */
  DETAIL = 'detail',
  /** The contract data of an accepted, not archived offer. */
  CORRECT = 'correct'
}
